import { Close } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { FormTextField } from '../../../../design/form/FormTextField';
import { ISSOFormErrors, ISSOFormState, SSOFormMode } from '../store/ISSOUI';

interface Props {
  open: boolean;
  mode: SSOFormMode;
  form: ISSOFormState;
  errors: ISSOFormErrors;
  isLoading: boolean;
  onChange: (patch: Partial<ISSOFormState>) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export const SSOProviderFormModal = observer(
  ({ open, mode, form, errors, isLoading, onChange, onSubmit, onCancel }: Props) => {
    const hasErrors = Object.keys(errors).length > 0;

    return (
      <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
          {mode === 'create' ? 'Создание SSO провайдера' : 'Редактирование SSO провайдера'}
          <IconButton
            aria-label="Close"
            size="small"
            onClick={onCancel}
            sx={{ position: 'absolute', right: 16 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormTextField
                label="Название"
                value={form.name}
                onChange={(v) => onChange({ name: v })}
                required
                errorMessage={errors.name ?? null}
              />
            </Grid>

            <Grid item xs={12}>
              <FormTextField
                label="Client ID"
                value={form.clientId}
                onChange={(v) => onChange({ clientId: v })}
                required
                errorMessage={errors.clientId ?? null}
              />
            </Grid>

            <Grid item xs={12}>
              <FormTextField
                label="Client Secret"
                value={form.clientSecret}
                onChange={(v) => onChange({ clientSecret: v })}
                required
                type="password"
                errorMessage={errors.clientSecret ?? null}
              />
            </Grid>

            <Grid item xs={12}>
              <FormTextField
                label="Issuer"
                value={form.issuer}
                onChange={(v) => onChange({ issuer: v })}
                required
                errorMessage={errors.issuer ?? null}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={onCancel} disabled={isLoading}>
            Отмена
          </Button>
          <Button variant="contained" color="primary" onClick={onSubmit} disabled={isLoading || hasErrors}>
            {mode === 'create' ? 'Создать' : 'Сохранить'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  },
);
